export default __webpack_public_path__ + "static/media/chart.6527ee16.svg";